import { FormControl, IconButton, InputBase, styled, SvgIcon } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '../../../../../../../../icons/svg/close.svg?react';
import SearchIcon from '../../../../../../../../icons/svg/search.svg?react';

type Props = {
  onClose: () => void;
  onSearch: (search: string | undefined) => void;
  variant?: 'dark' | 'light';
};
export type TableRoofSearchTextFieldProps = Props;

const StyledInput = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== 'variant'
})<{ variant: 'light' | 'dark' }>(({ theme, variant }) => ({
  height: '40px',
  borderRadius: '8px',
  background: variant === 'light' ? 'white' : theme.palette.grey[50]
}));

export const TableRoofSearchTextField: FC<Props> = ({ onSearch, variant = 'light', onClose }) => {
  const { t } = useTranslation('common');
  const [searchValue, setSearchValue] = useState<string>('');

  return (
    <FormControl>
      <StyledInput
        variant={variant}
        value={searchValue}
        placeholder={t('SEARCH')}
        autoFocus
        onChange={(event) => {
          setSearchValue(event.target.value);
          onSearch(event.target.value);
        }}
        startAdornment={
          <SvgIcon
            component={SearchIcon}
            sx={{
              marginX: '8px'
            }}
          />
        }
        endAdornment={
          <IconButton
            disableRipple
            onClick={() => {
              if (searchValue != '') {
                onSearch('');
              }
              setSearchValue('');
              onClose();
            }}
          >
            <SvgIcon component={CloseIcon} />
          </IconButton>
        }
      />
    </FormControl>
  );
};
